import { ref } from 'vue';
import { goToLogin } from '../../router';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5041';

const tenantService = (() => {
  const tenants = ref([]);
  const error = ref(null);
  const axios = require('axios');

  const instance = axios.create({
    baseURL: API_URL,
  });

  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        goToLogin();
      }
      return Promise.reject(error);
    }
  );

  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('jwt-token');
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const getTenantByTenantId = async (id) => {
    try {
      const response = await instance.get(`/Tenant/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener tenant por ID:', error);
      error.value = error;
      return null;
    }
  };

  const getTenantByName = async (name) => {
    try {
      const response = await instance.get(`/Tenant/GetByName/${name}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener tenant por nombre:', error);
      error.value = error;
      return null;
    }
  };

  const updateTenant = async (id, payload) => {
    const { data } = await instance.put(`/Tenant/${id}`, payload)
    return data
  }

  const createTenant = async (payload) => {
    const { data } = await instance.post('/Tenant', payload)
    return data
  }

    

  return {
    
    getTenantByTenantId,
    getTenantByName,
    updateTenant,
    createTenant,

  };
});

  
export default tenantService();

